import { useTranslation } from 'react-i18next';
/**
 * Loads translations for this library with proper type checking.
 *
 * @returns {UseTranslationResponse<'common-web-ui', undefined>} Translation hook response scoped to `common-web-ui`.
 */
export function useCommonWebTranslation() {
    return useTranslation('common-web-ui');
}
